import React, { useCallback, useEffect, useState } from "react";

import { A11y } from "@churchofjesuschrist/eden-buttons";
import { FileInput } from "@churchofjesuschrist/eden-form-parts";
import { blue30 as linkBlue } from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import documentService from "./document-service";
import useTranslation from "../../../utils/use-translations";

const defaultService = documentService();

const LinkButton = styled(A11y)`
  color: ${linkBlue};
`;
const stringGroups = [
  {
    name: "admin",
    keys: [
      "chooseFile",
      "copyURL"
    ]
  }
];

export const getFileUrl = (file) => `https://${window.location.hostname}/api/documents/${file.id}/contents`;

const DocumentUpload = ({
  service = defaultService, onClick, linkText, onFileChange: propOnFileChange, initialFile }) => {
  const { managedStrings } = useTranslation(stringGroups);
  const [file, setFile] = useState(null);

  const onFileChange = (e) => {
    if (e?.target?.value) {
      const reader = new FileReader();
      const { name, type } = e.target.value;
      reader.readAsDataURL(e.target.value);

      reader.onload = () => {
        const file = {
          userUploaded: true, name, type,
          base64String: reader.result
        };
        setFile(file);
      }

      reader.onerror = () => {
        setFile(null);
      }

    }
  }

  const onFileCopy = () => {
    navigator.clipboard.writeText(getFileUrl(file));
  }

  useEffect(() => {
    setFile(initialFile);
  }, [initialFile]);

  useEffect(() => {
    const upload = async () => {
      if (file?.userUploaded) {
        const results = await service.uploadDocument(file);
        if (results) {
          setFile(results);
          propOnFileChange(results);
        }
      }
    }
    upload();
  }, [file, service, propOnFileChange]);

  return (<>
    {file?.id ? <LinkButton onClick={onClick || onFileCopy}>
      {linkText || managedStrings.copyURL}
    </LinkButton> :
      <FileInput
        fileType={"base64"}
        multiple={false}
        onChange={onFileChange}
      >
        {managedStrings.chooseFile}
      </FileInput>
    }
  </>
  )
}

export const SingleDocumentUpload = ({ service, removeText, onFileChange: propOnFileChange }) => {
  const [resetFile, setResetFile] = useState(null);
  const [documentId, setDocumentId] = useState(null);

  const onFileChange = useCallback((file) => {
    setDocumentId(file.id);
    propOnFileChange(getFileUrl(file));
  }, [propOnFileChange]);

  const onFileReset = useCallback(() => {
    propOnFileChange("");
    setResetFile({
      timestamp: new Date().getTime()
    });
    service.deleteDocument(documentId);
    setDocumentId(null);
  }, [documentId, propOnFileChange, service]);

  return <DocumentUpload
    initialFile={resetFile}
    linkText={removeText}
    onFileChange={onFileChange}
    onClick={onFileReset}
    service={service}
  />
}

export default DocumentUpload;
